import { Box, Button, Collapse, Typography } from '@mui/material'
import { memo, useCallback, useState } from 'react'
import { IoChevronDown, IoChevronUp } from 'react-icons/io5'

import { QuestionStorePayload } from '@/types'

interface QuestionCardQuestionPreviewProps {
  question: QuestionStorePayload
}

export const QuestionCardQuestionPreview = memo<QuestionCardQuestionPreviewProps>(
  ({ question }) => {
    const [expanded, setExpanded] = useState<boolean>(false)

    const handleToggle = useCallback(() => {
      setExpanded((prev) => !prev)
    }, [])

    return (
      <Box data-qa="question-card-question-preview" sx={{ mt: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            marginBottom: 2,
            lineHeight: 1.4,
          }}>
          {question.question}
        </Typography>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box
            sx={{
              p: 3,
              mb: 2,
              borderRadius: 2,
              border: ({ palette }) => `1px solid ${palette.divider}`,
            }}>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ lineHeight: 1.6 }}
              dangerouslySetInnerHTML={{ __html: question.description }}
            />
          </Box>
        </Collapse>

        <Button
          onClick={handleToggle}
          variant="text"
          startIcon={expanded ? <IoChevronUp /> : <IoChevronDown />}
          sx={{
            textTransform: 'none',
            fontWeight: 500,
          }}>
          {expanded ? 'Mostrar menos' : 'Ler descrição completa'}
        </Button>
      </Box>
    )
  },
)

QuestionCardQuestionPreview.displayName = 'QuestionCardQuestionPreview'
